'use strict';

import {
    BufferEncoders,
    RSocketClient,
    MESSAGE_RSOCKET_COMPOSITE_METADATA,
} from "rsocket-core";
import RSocketWebSocketClient from "rsocket-websocket-client";


function newClientInstance() {
    const url = (location.protocol === 'https:' ? 'wss://' : 'ws://') + location.hostname +
        (location.protocol === 'https:' ? ':2053' : ':7000') + '/rsocket';
    return new RSocketClient({
        setup: {
            keepAlive: 60000,
            lifetime: 180000,
            dataMimeType: 'application/json',
            metadataMimeType: MESSAGE_RSOCKET_COMPOSITE_METADATA.string,
        },
        transport: new RSocketWebSocketClient({
            // eslint-disable-next-line no-restricted-globals
            url: url
        }, BufferEncoders),
    });
}

let socket = null

async function singleton() {
    if (!socket) {
        socket = await newClientInstance().connect()
    }
    if (socket.availability() !== 1) {
        socket.close();
        socket = await newClientInstance().connect()
    }
    return socket
}


export default {
    socket: singleton
}

